import { useUser } from '@descope/react-sdk'
import { useMemo } from 'react'

import { useListUsers } from '@/api/list-users.hook'

import type { DropdownSelectItem } from '@/components/lemmala-design-system/dropdown/dropdown-select.types'

import { buildPersonDropdownItems, getCurrentUserFilterId, getPersonDisplayName } from './utils'

export const usePersonFilterDropdownItems = (enabled: boolean) => {
  const { user: currentUser } = useUser()
  const { data: allUsers, isPending } = useListUsers(enabled)

  return useMemo(() => {
    if (!enabled) {
      return {
        dropdownItems: [] as DropdownSelectItem[],
        optionIds: [] as string[],
        isLoading: false,
      }
    }

    const currentUserFilterId = getCurrentUserFilterId(allUsers, currentUser)
    const seenDisplayNames = new Set<string>()
    const people = allUsers.flatMap((user) => {
      const displayName = getPersonDisplayName(user.name, user.email)
      if (seenDisplayNames.has(displayName)) return []
      seenDisplayNames.add(displayName)
      return [{ id: displayName, displayName }]
    })
    const dropdownItems = buildPersonDropdownItems(people, currentUserFilterId)

    return {
      dropdownItems,
      optionIds: dropdownItems.map((item) => item.id),
      isLoading: isPending,
    }
  }, [allUsers, currentUser, enabled, isPending])
}
